import React, { useState } from 'react';
import { Search, Empty, Loading } from 'react-vant';
import { ArrowLeft, Arrow, FriendsO } from '@react-vant/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../api/request';

const SportsAthletes = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [searched, setSearched] = useState(false);

  const onSearch = async (val) => {
    if (!val) return;
    setLoading(true);
    setSearched(true);
    try {
      const res = await request.get('/v2/academic/students/', {
        params: { search: val, page_size: 20 }
      });
      setList(res.items || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--canvas-bg, #f8fafc)', paddingBottom: 60 }}>
      {/* 沉浸式星瀚空天蓝页眉 */}
      <div style={{
        background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
        padding: '44px 16px 20px',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* 装饰半透圆 */}
        <div style={{
          position: 'absolute', top: -30, right: -30,
          width: 140, height: 140, borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.08)'
        }} />

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
          <div
            onClick={() => navigate(-1)}
            style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            <ArrowLeft color="#fff" fontSize={18} />
          </div>

          <div style={{ textAlign: 'center' }}>
            <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#fff', letterSpacing: '-0.2px' }}>
              运动员查询
            </h1>
            <p style={{ margin: '2px 0 0', fontSize: 11.5, color: 'rgba(255,255,255,0.85)', fontWeight: 400 }}>
              快速检索参赛选手、赛程与战报
            </p>
          </div>

          <div style={{ width: 36 }} />
        </div>
      </div>

      {/* 搜索框区域 */}
      <div style={{ padding: '12px 16px', background: '#ffffff', borderBottom: '1px solid #e2e8f0' }}>
        <Search
          value={value}
          onChange={setValue}
          placeholder="搜索运动员姓名或学号"
          onSearch={onSearch}
          shape="round"
          background="transparent"
          style={{ padding: 0 }}
        />
      </div>

      <div style={{ padding: '12px 16px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}>
            <Loading type="spinner" color="#056b4f" vertical>检索运动员中...</Loading>
          </div>
        ) : list.length > 0 ? (
          <div style={{
            background: '#ffffff',
            borderRadius: 16,
            padding: '4px 16px',
            boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
            border: '1px solid #f1f5f9'
          }}>
            {list.map((item, idx) => {
              const isLast = idx === list.length - 1;
              return (
                <div 
                  key={idx}
                  onClick={() => navigate(`/sports/athlete/${item.id}`)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '14px 0',
                    borderBottom: isLast ? 'none' : '1px solid #f1f5f9',
                    cursor: 'pointer'
                  }}
                >
                  <div style={{ 
                    width: 44, height: 44, borderRadius: 22,
                    background: '#f0fdf4', 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', 
                    marginRight: 14, color: '#056b4f', fontWeight: 800, fontSize: 17,
                    border: '1.5px solid #a7f3d0',
                    flexShrink: 0
                  }}>
                    {item.real_name?.[0]}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>
                      {item.real_name}
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {item.class_name && (
                        <span style={{
                          background: '#f0fdf4', color: '#056b4f', fontSize: 11,
                          fontWeight: 600, padding: '1px 6px', borderRadius: 4
                        }}>
                          {item.class_name}
                        </span>
                      )}
                      {item.student_no && (
                        <span style={{
                          background: '#f8fafc', color: '#64748b', fontSize: 11,
                          fontWeight: 500, padding: '1px 6px', borderRadius: 4,
                          border: '1px solid #e2e8f0'
                        }}>
                          学号 {item.student_no}
                        </span>
                      )}
                    </div>
                  </div>

                  <Arrow fontSize={14} style={{ color: '#94a3b8', marginLeft: 8 }} />
                </div>
              );
            })}
          </div>
        ) : searched ? (
          <div style={{ padding: '60px 0' }}>
            <Empty description="未找到相关运动员" />
          </div>
        ) : (
          <div style={{ padding: '60px 0' }}>
            <Empty
              image={<FriendsO size={72} color="#056b4f" style={{ opacity: 0.6 }} />}
              description={
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 16, color: '#0f172a', fontWeight: 700, marginBottom: 6 }}>查找运动员</div>
                  <div style={{ fontSize: 13, color: '#64748b' }}>输入姓名或学号搜索，即可查看其参赛计划与过往战绩</div>
                </div>
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SportsAthletes;
